'use client'

import { useReportWebVitals } from 'next/web-vitals'

declare global {
  interface Window {
    gtag: Function
  }
}

const logWebVitals = (metric: any) => {
  const body = JSON.stringify(metric)
  const url = '/api/v1/analytics'
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, body)
  } else {
    fetch(url, { body, method: 'POST', keepalive: true })
  }

  window.gtag?.('event', metric.name, {
    value: Math.round(
      metric.name === 'CLS' ? metric.value * 1000 : metric.value,
    ), // values must be integers
    event_label: metric.id, // id unique to current page load
    non_interaction: true, // avoids affecting bounce rate.
  })
}

export function WebVitals() {
  useReportWebVitals(logWebVitals)

  return null
}
